/**
 * Atmosphere amenity SKUs COR-60 forbids on any Places FieldMask.
 *
 * Google bills a request at the highest tier touched by the mask. These
 * fields are Enterprise + Atmosphere. `websiteUri`, `currentOpeningHours`,
 * and `editorialSummary` already ship in other masks and are grandfathered
 * (PIP-241 tracks `websiteUri`); this list is the amenity set COR-60 must
 * not introduce (`parkingOptions` in particular).
 */
export const FORBIDDEN_PLACES_ATMOSPHERE_AMENITY_FIELDS = [
  'parkingOptions',
  'outdoorSeating',
  'paymentOptions',
  'fuelOptions',
  'evChargeOptions',
] as const;

export type ForbiddenPlacesAtmosphereAmenityField =
  (typeof FORBIDDEN_PLACES_ATMOSPHERE_AMENITY_FIELDS)[number];
